export class KeyValuePair<T = string> {
  constructor(public key: string, public value: T) { }
}